import React from 'react'

function Contact() {
  return (
    <div className='contact-container'>
      <h1 className="page-title">Contact Us</h1>
      <div className="contact-text">
        <p>For inquiries about the Blackbird 66 Mk.1 or to contact JR about future projects, email him directly at <a href="mailto:jrhildebrand66@gmail.com" style={{color: 'whitesmoke'}}>jrhildebrand66@gmail.com</a> </p>
      </div>
    </div>
  )
}

export default Contact
